module.exports = __webpack_public_path__ + "img/bg-image.c586c5fe.png";